<template>
  <div>
    <p>Id : {{dealership.id}}</p>
    <p>Name: {{dealership.name}}</p>
    <p>Address: {{dealership.address}}</p>
    <button v-if="is_id(dealership.id.toString()) === false" @click="createDealer(dealership)">Add this Dealership</button>
    <router-link v-if="current_id > 0" :to="'dealerships/' + current_id" >Open Dealership</router-link>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "DealerCell",

  props: {
    dealership: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      now: new Date().getTime(),
      current_id:  0
    };
  },
  computed: {
    ...mapState({
      dealerships: (state) => state.dealerships.all
    }),
  },
  methods: {
    createDealer(params) {
      this.formState = "loading";
      params.dealership_id = params.id.toString();
      params.address_from_widget = params.address.replaceAll('*','').replaceAll('#','');
      console.log(params);

      this.$store
        .dispatch("createDealership", params)
        .then((resp) => {
          this.formState = "done";
          this.errors = {};
          alert("Dealership added successfully");
          return true;
      })
        .catch((err) => {
         console.log(err);
          this.errors = err.response.data.errors;
          this.formState = "normal";
      });
  },
    is_id(search) {
      const searchValue = search;
      const maintainable = this.dealerships.filter(
      (x) =>
        !searchValue.length ||
        x.dealership_id.toLowerCase().includes(searchValue.toLowerCase()),
    );
      this.current_id = maintainable.length === 0 ? 0 : maintainable[0].id;
    return maintainable.length > 0;
  },
    }
};
</script>
